<template>
  <div class="snow-wrapper">
    <div class="bg">
      <img src="../../assets/images/snow/bg.png" alt="">
    </div>
    <div class="content-wrapper">
      <div class="text">
        <img src="../../assets/images/snow/text.png" alt="">
      </div>
      <div class="coupon">
        <img src="../../assets/images/snow/coupon.png" alt="" @click="goCoupon">
      </div>
    </div>
    <div class="rule-wrapper">
      <img src="../../assets/images/snow/rule.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {
    goCoupon () {
      // eslint-disable-next-line no-undef
      dsBridge.call('callNativeView', {
        androidGoPage: '/wt/WtSportCouponActivity',
        iosGoPage: 'GXSCGainCouponController'
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.snow-wrapper {
  min-height: 100vh;
  background: #D7EDFA;
  padding-bottom: 20px;
}
.bg {
  img {
    width: 100%;
  }
}
.content-wrapper {
  position: relative;
  z-index: 10;
  margin: -20px 16px 15px 16px;
  padding: 20px;
  border-radius: 5px;
  background: #fff;
  img {
    width: 100%;
  }
  .coupon {
    margin-top: 20px;
  }
}
.rule-wrapper {
  margin: 12px 6px;
  border-radius: 5px;
  img {
    width: 100%;
  }
}
</style>
